import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=6c0aeffa&scoped=true&"
import script from "./countries.vue?vue&type=script&lang=js&"
export * from "./countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0aeffa",
  null
  
)

export default component.exports